import moment from "moment";
import React from "react";

function UnReadNotificationPopup({ setIsViewDetails, isViewDetails }) {
  console.log("isViewDetailspopoup", isViewDetails?.details?.admin_name);

  return (
    <div className="img-popup-design">
      <div className="img-popup" style={{ height: "auto", padding: "20px" }}>
        {/* <h3 className="f2 mb-3">Notification Description</h3> */}
        <div
          style={{
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            display: "flex",
          }}
        >
          <p style={{ fontSize: 18, fontWeight: "700" }}>Message :</p>
          <p
            style={{
              fontSize: 18,
              fontWeight: "500",
              border: "1px solid #000",
              width: "100%",
              textAlign: "left",
              padding: 10,
              borderRadius: 8,
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            {isViewDetails?.details?.notification_description &&
              isViewDetails?.details?.notification_description}
          </p>
        </div>
        <div
          style={{
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            display: "flex",
          }}
        >
          <p style={{ textTransform: "capitalize", color: "#adadad" }}>
            {isViewDetails?.details?.admin_name &&
              isViewDetails?.details?.admin_name}
          </p>
          <p style={{ color: "#adadad" }}>
            {isViewDetails?.details?.notification_updated_at &&
              moment(isViewDetails?.details?.notification_updated_at).format(
                "DD/MM/YYYY",
              )}
          </p>
        </div>
        <div className="d-flex ac-jb gap-3">
          <button
            onClick={() => {
              setIsViewDetails({
                ispopUp: false,
                details: {},
              });
            }}
            className="back-btn f2 w-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default UnReadNotificationPopup;
